import {
  CLICK_THROUGH_LINK,
  LANDSCAPE_IMAGE,
  SQUARE_IMAGE,
  LANDSCAPE_LOGO,
  SQUARE_LOGO,
  NAME,
  HEADLINES_LIST,
  DESCRIPTIONS_LIST,
  BUSINESS_NAME,
  getImageAssets
} from '../../fields'
import { LONG_HEADLINE } from './fields'
import { googleAdsCallToActionList } from '../../../../../constants/selectLists/googleAdsCallToActionList'
import { CALL_TO_ACTION } from '../../../../Facebook/AdForms/fields'

export const transformValuesToBE = values => {
  const callToActionLabel = googleAdsCallToActionList.find(text => text.value === values[CALL_TO_ACTION])?.label

  return {
    // in our create form we have just 1 link, but BE requires link to be an array:
    [CLICK_THROUGH_LINK]: [values[CLICK_THROUGH_LINK]],
    [NAME]: values[NAME],
    responsive_display_ad: {
      marketing_images: getImageAssets(values[LANDSCAPE_IMAGE]),
      square_marketing_images: getImageAssets(values[SQUARE_IMAGE]),
      logo_images: getImageAssets(values[LANDSCAPE_LOGO]),
      square_logo_images: getImageAssets(values[SQUARE_LOGO]),
      headlines: values[HEADLINES_LIST],
      [LONG_HEADLINE]: { text: values[LONG_HEADLINE] },
      descriptions: values[DESCRIPTIONS_LIST],
      business_name: values[BUSINESS_NAME],
      call_to_action_text: callToActionLabel,
      control_spec: {
        enable_autogen_video: false
      }
    }
  }
}
